import React, { Component } from "react";
import { Carousel } from "antd";

import BalanceAccountingConfig from "./BalanceAccountingConfig";
import BalanceModels from "./BalanceModels";
import { ModalConfirm } from "tamtam-components";
import _ from "i18n";

class BalanceUpload extends Component {
  render() {
    const props = {
      dots: false,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1
    };

    return (
      <div>
        <Carousel ref={this.props.carouselRef} {...props}>
          <div>
            <BalanceAccountingConfig />
          </div>
          <div>
            <BalanceModels
              handleNextToAnnexeUpload={this.props.handleNextToAnnexeUpload}
              handleSaveBalance={this.props.handleSaveBalance}
              loadingBalance={this.props.loadingBalance}
            />
          </div>
        </Carousel>

        {this.props.isHorusSynchroImport && (
          <ModalConfirm
            type={"return"}
            isOpen={this.props.isUploadConfirmModalOpen}
            onCancel={this.props.handleOnUploadConfirmClose}
            onConfirm={this.props.handleOnUploadConfirm}
            inProcess={false}
            actionFailed={false}
            title={_("UploadConfirm")}
            text={_("UploadConfirmContent")}
            labelNo={_("cancel")}
            labelYes={_("Confirm")}
            labelError={"Error"}
          />
        )}
      </div>
    );
  }
}

export default BalanceUpload;



// WEBPACK FOOTER //
// ./src/components/BalanceUpload/BalanceUpload.js